if(!customElements.get('featured-collection')){
    class FeaturedCollection extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.buttonTags = this.querySelectorAll('.button-tag');
            this.products = this.querySelectorAll('.featured-collection__products');
            this.buttonTags.forEach(item => {
                item.addEventListener("click", this.updateProducts.bind(this));
                item.addEventListener("keydown", e => {
                    if(e.key === 'Enter'){
                        this.updateProducts(e);
                    }
                });
            });

            this.initializeProductSwiper();
        }

        initializeProductSwiper(){
            this.productSwiperContainers = this.querySelectorAll(".featured-collection__product-by-collection .swiper-container:not(.swiper-container--product-card)");
            if(this.productSwiperContainers.length == 0) return;

            this.productSwiperContainers.forEach(swiperContainer => {
                const slides = swiperContainer.querySelectorAll('.swiper-slide:not(.swiper-slide--product-card)');
                if(slides.length <= 1) return;

                const itemsPerView = parseInt(swiperContainer.dataset.itemsPerView);
                const itemsPerViewMobile = parseInt(swiperContainer.dataset.itemsPerViewMobile);
                const totalSlides = swiperContainer.dataset.itemsTotal;
                const autoplay = swiperContainer.dataset.autoplay === 'true';
                const speed = parseInt(swiperContainer.dataset.speed);
                const loop = swiperContainer.dataset.loop === 'true';
                const visibleItemsPerView = (itemsPerView && totalSlides > itemsPerView)? itemsPerView : totalSlides;
                const spaceBetween = parseInt(swiperContainer.dataset.gap);
                const breakpoints = {
                    0: { slidesPerView: itemsPerViewMobile },
                    500: { slidesPerView: 2 },
                    768: { slidesPerView: visibleItemsPerView > 3? 3 : visibleItemsPerView },
                    1400: { slidesPerView: visibleItemsPerView > 4? 4 : visibleItemsPerView }
                }

                const parent = swiperContainer.closest('.featured-collection__product-by-collection');

                var swiperSettings = {
                    init: false,
                    initialSlide: 0,
                    loop: loop,
                    centeredSlides: false,
                    speed: 500,
                    watchOverflow: true,
                    breakpoints: breakpoints,
                    observer: true,
                    observeSlideChildren: true,
                    watchSlidesProgress: true,
                    autoHeight: false,
                    spaceBetween: spaceBetween,
                    on: {
                        init: () => {
                            const paginationBullets = parent?.querySelectorAll(".swiper-pagination:not(.swiper-pagination--product-card) .swiper-pagination-bullet");
                            if(paginationBullets.length > 0){
                                parent.style.setProperty('--pagination-width', `calc(100% / ${paginationBullets.length})`);
                                paginationBullets.forEach((item, index) => {
                                    item.setAttribute('data-index', `${index}`);
                                });
                                setTimeout(() => {
                                    parent.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')?.classList.add('loaded');
                                    this.checkSwiperLock(parent, swiper);
                                }, 500);
                            }
                        },
                        slideChange: () => {
                            const activePagination = parent?.querySelector(".swiper-pagination:not(.swiper-pagination--product-card) .swiper-pagination-bullet-active");
                            if(activePagination){
                                const activePaginationIndex = parseInt(activePagination.dataset.index);
                                parent.style.setProperty('--pagination-translate-x', `calc(100% * ${activePaginationIndex})`);
                            }
                        },
                        resize: () => {
                            const activePagination = parent?.querySelector(".swiper-pagination:not(.swiper-pagination--product-card) .swiper-pagination-bullet-active");
                            if(activePagination){
                                const activePaginationIndex = parseInt(activePagination.dataset.index);
                                parent.style.setProperty('--pagination-translate-x', `calc(100% * ${activePaginationIndex})`);
                            }
                        }
                    }
                }

                if(parent && parent.querySelector(".swiper-navigation-wrapper:not(.swiper-navigation-wrapper--product-card)")){
                    swiperSettings.navigation = {
                        nextEl: parent?.querySelector('.button-next:not(.button-next--product-card)'),
                        prevEl: parent?.querySelector('.button-previous:not(.button-previous--product-card)')
                    }
                }

                if(parent.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')){
                    swiperSettings.pagination = {
                        el: parent.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')
                    }
                }

                if(autoplay && !isNaN(speed)){
                    swiperSettings.autoplay = {
                        delay: speed
                    }
                }

                const swiper = new Swiper(swiperContainer, swiperSettings);
                swiper.init();

                swiper.on("resize", () => { swiper.update(); });
                swiper.on("resize", () => { this.checkSwiperLock(parent, swiper) });
            });

            this.setupFocusListeners();
        }

        checkSwiperLock(parent, swiper){
            if(!swiper) return;
            if(!parent.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)")) return;

            if(swiper.isLocked){
                parent.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)").classList.add("hidden");
            }else{
                parent.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)").classList.remove("hidden");
            }
        }


        setupFocusListeners(){
            this.querySelectorAll(".button-next, .button-previous").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }

        updateProducts(e){
            if(!e.currentTarget) return;

            const currentIndex = e.currentTarget.dataset.index;
            if(!currentIndex) return;

            this.buttonTags.forEach(item => { item.classList.remove('active') });
            
            const currentCollection = e.currentTarget;
            currentCollection.classList.add('active');

            this.products.forEach(item => {
                item.querySelectorAll('.in-view').forEach(elem => {
                    elem.classList.remove('in-view');
                });
                if(item.dataset.index === currentIndex){
                    item.setAttribute('aria-hidden', 'false');
                    item.removeAttribute('inert');
                    setTimeout(() => {
                        item.querySelectorAll('.animation-element').forEach(elem => {
                            elem.classList.add('in-view');
                        });
                    }, 10);
                 
                }else{
                    item.setAttribute('aria-hidden', 'true');
                    item.setAttribute('inert', '');
                }
            });
        }
    }

    customElements.define('featured-collection', FeaturedCollection);
}